import { ax } from 'src/client'
import * as serviceURLs from './serviceURLS'

export const getInvestorById = (investorId) => {
  return ax.get(`${serviceURLs.INVESTORS_URL}/${investorId}`)
}

export const getPartners = () => {
  return ax.get(serviceURLs.PARTNERS_URL, {
    params: {
      limit: 999,
      offset: 0,
      sort_by: 'name',
      descending: false
    }
  })
}

export const getInvestors = () => {
  return ax.get(serviceURLs.FIND_INVESTORS)
}

export const getAccountsForETP = (id) => {
  return ax.get(serviceURLs.ACCOUNTS_ETP, {
    params: {
      owner_id: id
    }
  })
}

export const findAccounts = () => {
  return ax.get(serviceURLs.ACCOUNTS_URL, { params: {} })
}

export const getAccounts = (companyId) => {
  return ax.get(serviceURLs.ACCOUNTS_URL, { params: { owner_id: companyId } })
}

export const getAccountById = (accountId) => {
  return ax.get(serviceURLs.ACCOUNT_URL.replace(':id', accountId))
}

export const getAccountsByCompanyId = (companyId) => {
  return ax.get(serviceURLs.ACCOUNTS_URL, { params: { owner_id: companyId } })
}

export const getBalances = (accountId) => {
  return ax.get(serviceURLs.BALANCES_URL.replace(':account_id', accountId))
}

export const getBalancesETP = (accountId) => {
  return ax.get(serviceURLs.GET_BALANCES_ETP.replace(':account_id', accountId))
}

export const getSupportedCountries = () => {
  return ax.get(serviceURLs.SUPPORTED_COUNTRIES_URL)
}

export const getStrategies = async (params) => {
  return ax.get(serviceURLs.STRATEGIES_URL, { params: { ...params } })
}

export const getStrategyDetails = async (strategyID, product) => {
  return ax.get(serviceURLs.STRATEGY_DETAILS_URL.replace(':id', strategyID), {
    params: { product }
  })
}

export const createStrategy = async (payload, product) => {
  return ax.post(serviceURLs.STRATEGIES_URL, payload, {
    params: { product }
  })
}

export const updateStrategy = async (strategyID, payload, product) => {
  return ax.put(
    serviceURLs.STRATEGY_EDIT_URL.replace(':id', strategyID),
    payload,
    { params: { product } }
  )
}
